var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnytime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_46_204)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.083 0H4.91634C2.38301 0 0.333008 2.05 0.333008 4.58333V30.4167C0.333008 32.95 2.38301 35 4.91634 35H18.4997C17.0997 32.7833 16.1663 30.1667 16.1663 27.1667V23.1C15.9163 23.25 15.633 23.3333 15.333 23.3333H6.99968C6.08301 23.3333 5.33301 22.5833 5.33301 21.6667C5.33301 20.75 6.08301 20 6.99968 20H15.333C15.6497 20 15.933 20.0833 16.183 20.2333C16.2497 18.8167 16.9163 17.5167 17.9663 16.6667H6.99968C6.08301 16.6667 5.33301 15.9167 5.33301 15C5.33301 14.0833 6.08301 13.3333 6.99968 13.3333H21.9997C22.6997 13.3333 23.2997 13.7667 23.5497 14.3833L28.2997 12.7667C28.4163 12.7167 28.533 12.6833 28.6663 12.6667V4.58333C28.6663 2.05 26.6163 0 24.083 0ZM13.6663 10H6.99968C6.08301 10 5.33301 9.25 5.33301 8.33333C5.33301 7.41667 6.08301 6.66667 6.99968 6.66667H13.6663C14.583 6.66667 15.333 7.41667 15.333 8.33333C15.333 9.25 14.583 10 13.6663 10Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.203 18.8984L30.453 15.9218C30.1047 15.8034 29.7264 15.8034 29.378 15.9218L20.628 18.8984C19.953 19.1284 19.498 19.7634 19.498 20.4768V27.1734C19.498 35.6184 28.863 39.6984 29.2614 39.8684C29.4714 39.9568 29.6947 40.0001 29.9164 40.0001C30.138 40.0001 30.3614 39.9568 30.5697 39.8668C30.968 39.6968 40.333 35.6184 40.333 27.1734V20.4768C40.333 19.7618 39.8797 19.1284 39.203 18.8984ZM35.833 25.1668L30.833 31.8334C30.543 32.2201 30.1014 32.4618 29.618 32.4951C29.578 32.4984 29.538 32.5001 29.4997 32.5001C29.058 32.5001 28.6347 32.3268 28.3214 32.0118L24.988 28.6784C24.3364 28.0268 24.3364 26.9734 24.988 26.3218C25.6397 25.6701 26.693 25.6701 27.3447 26.3218L29.3197 28.2968L33.1664 23.1668C33.718 22.4318 34.7631 22.2801 35.4981 22.8334C36.2364 23.3851 36.3864 24.4301 35.833 25.1668Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_46_204"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.333008)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnytime);
export default __webpack_public_path__ + "static/media/anytime.6d92b6d6ac92cc2315894be81966be4b.svg";
export { ForwardRef as ReactComponent };